import Image from "next/image";

type IconGridItem = {
  icon: string;
  title: string;
  description: string;
};

type IconGridSectionProps = {
  heading?: string;
  grid_items: IconGridItem[];
  columns?: number;
  add_background?: boolean;
  add_bottom_border?: boolean;
};

export default function IconGridSection({
  heading,
  grid_items,
  columns = 2,
  add_background = false,
  add_bottom_border = false,
}: IconGridSectionProps) {
  const gridCols = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
    4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
  }[columns] || "grid-cols-1 md:grid-cols-2";

  // Helper function to get the correct icon source
  const getIconSrc = (icon: string) => {
    // If it's a full URL, use it directly
    if (icon.startsWith("http://") || icon.startsWith("https://")) {
      return icon;
    }
    // Otherwise, prepend /images/
    return `/images/${icon}`;
  };

  const content = (
    <>

      <div className={`grid ${gridCols} gap-8 ${add_bottom_border ? "pb-8 border-b border-gray-200" : ""}`}>
        {grid_items.map((item, index) => (
          <div key={index} className="flex items-start gap-4">
            <div className="w-[20%] flex justify-start">
              <Image
                src={getIconSrc(item.icon)}
                width={56}
                height={56}
                alt={item.title}
                className="w-18 h-18"
              />
            </div>
            <div className="flex-1">
              <div className="font-bold text-primary-700">{item.title}</div>
              <div className="text-gray-500 text-sm">{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  if (add_background) {
    return (
      <section className="w-screen relative left-1/2 right-1/2 -mx-[50vw] bg-gradient-to-b from-[rgba(237,237,249,0)] to-[#DEE5E8] pt-12 pb-12">
        <div
          className="absolute left-0 bottom-0 w-[300px] h-[300px] bg-no-repeat bg-left-bottom bg-contain pointer-events-none"
          style={{
            backgroundImage: "url(/images/left-corner-supergrafis.png)",
          }}
        />
        <div className="container max-w-7xl mx-auto items-start gap-8 flex">
          <div className="w-80 shrink-0" />
          <div className="flex-1 flex flex-col">
            {content}
          </div>
        </div>
      </section>
    );
  }

  return <div className="flex flex-col">{content}</div>;
}
